import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import { TenantCommunityGuard } from '@src/components/guard/CommunityGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import CommunityChannelListForm from '@src/features/shared/community/CommunityChannelListForm';
import CommunityDefaultLayout from '@src/layouts/shared/CommunityDefaultLayout';

function CommunityChannels() {
  return (
    <TenantCommunityGuard
      canRoles={[TENANT_ROLE.ADMIN]}
      canService={[SERVICE.ONLINE_COMMUNITY]}
      checkAuthenticate={true}
    >
      <CommunityDefaultLayout>
        <CommonHelmet />
        <CommunityChannelListForm />
      </CommunityDefaultLayout>
    </TenantCommunityGuard>
  );
}

export default CommunityChannels;
